function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "15",
  height: "12",
  viewBox: "0 0 15 12",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M3.196 5.056l3.458-3.458c.376-.376.376-.978 0-1.316-.376-.376-.977-.376-1.316 0L.263 5.319A.968.968 0 000 5.996c0 .226.075.489.263.677l5.038 5.038c.376.376.977.376 1.316 0 .375-.376.375-.978 0-1.316L3.158 6.937h10.977c.489 0 .865-.414.865-.94 0-.527-.338-.94-.827-.94H3.195z",
  fill: "#000",
  fillRule: "evenodd"
})));